import { render, staticRenderFns } from "./SelectContactos.vue?vue&type=template&id=1b5ad94c"
import script from "./SelectContactos.vue?vue&type=script&lang=js"
export * from "./SelectContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports